import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-up",
  "use": "svg_arrow-up-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 5\" id=\"svg_arrow-up\"><path fill-rule=\"evenodd\" fill=\"currentColor\" d=\"M4.969.044.037 5.005h9.925L4.969.044z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol